import { Component, OnInit, Input, SimpleChanges, OnChanges } from '@angular/core';
import { AssessmentAgencyService } from 'projects/services/src/app/API/assessment-agency.service';
import { getAADetailForm } from './aa-details.element';
import { IDFormControl } from '../d-form/d-form.helpers';
import { Helpers } from 'projects/training-calendar/src/app/helpers';

@Component({
  selector: 'app-aa-details',
  templateUrl: './aa-details.component.html',
  styleUrls: ['./aa-details.component.css']
})
export class AaDetailsComponent implements OnInit, OnChanges {
	@Input() aaId: string;
	aaDetailFormControl: IDFormControl
	aaDetailForm = getAADetailForm();
	constructor(
		private assessmentAgencyService: AssessmentAgencyService
	) { }

	ngOnInit() {
	}
	ngOnChanges(changes: SimpleChanges) {
		console.log(changes)
		this.getAADetails()
	}

	getAADetails() {
		if (!this.aaId) {
			return
		}
		this.assessmentAgencyService.getAssesmentAgencyByUserName(this.aaId)
			.subscribe(res => {
			this.mapAaDetailsWithForm(res)
			console.log(res)
		})
	}

	mapAaDetailsWithForm(aaDetails) {
		console.log(aaDetails)
		const address = aaDetails.address || {}
		const spoc = aaDetails.spoc || {}
		const patch = {
			aaName : aaDetails.name,
			aaUserName : aaDetails.userName,
			address : address.address1,
			landmark : address.landmark,
			pincode : address.pinCode,
			state : Helpers.getValueFromObject(address, 'state.name'),
			district : Helpers.getValueFromObject(address, 'district.name'),
			// tehsil : Helpers.getValueFromObject(address, 'tehsil.name'),
			// village : Helpers.getValueFromObject(address, 'city.name'),
			parliamentaryConstituency : Helpers.getValueFromObject(address, 'parliamentaryConstituency.name'),
			spocName : spoc.firstName,
			email : spoc.email,
			mobileNumber : spoc.mobileNumber,
		}
		this.aaDetailFormControl.patchValues(patch)
	}

}
